module.exports = __webpack_public_path__ + "static/media/satellite.3b2e610b.svg";